import { render, staticRenderFns } from "./InfoCards.vue?vue&type=template&id=0c4b254c"
import script from "./InfoCards.vue?vue&type=script&lang=js"
export * from "./InfoCards.vue?vue&type=script&lang=js"
import style0 from "./InfoCards.vue?vue&type=style&index=0&id=0c4b254c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports